import { Injectable } from "@angular/core";
import { AbstractFindOneByIdService } from "src/app/modules/core/service/v2/service/findone/abstractFindOneById.service";
import {DocumentTemplateRepository} from "../../impl/service/ngrx/documentTemplate.repository";
import {DocumentTemplateDataServiceAdapter} from "../../impl/service/ngrx/documentTemplateDataService.adapter";
import {DocumentTemplateModel} from "../entity/documentTemplate.model";

@Injectable()
export class DocumentTemplateFindOneByIdService extends AbstractFindOneByIdService<DocumentTemplateModel, DocumentTemplateModel> {
    constructor(repository: DocumentTemplateRepository, dataServiceAdapter: DocumentTemplateDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}

